{
  "name": "@shopliftr/admin",
  "description": "MGD/Shopliftr Administration Portal",
  "version": "19.28.0"
}
